module.exports = __webpack_public_path__ + "img/pp.67fae63e.png";